/**
 * Mordeczka.eu - Public Frontend
 * 
 * Main application entry point.
 * Domain: mordeczka.eu
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/main.scss';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
